export default __webpack_public_path__ + "static/media/1876.ddf45a16.png";